import React from 'react';
import './playCanvas.css';
import { socketIOService } from '../../services/socketio.service.js';
import { OrbitCamera } from "./pcUtils/orbitCamera.js";
import { MouseInput } from "./pcUtils/mouseInput.js";
import { TouchInput } from "./pcUtils/touchInput.js";
import { CustomLoading } from './pcUtils/customLoading.js';
import { HotSpot } from "./pcUtils/hotSpot.js";
import CameraData from './pcUtils/cameraData.json';
import { Utils } from "../../js/utils.js";

class PlayCanvasComponent extends React.Component {
	constructor(props) {
		super(props);
		this.pcApp = null;
		this.camera = null;
		this.currentScene = "";
		this.previousScene = "";
		this.resetPoint = new pc.Vec3(28.5, 9.87, 15.95);
		this.class = 'playCanvas-closed';
		this.canvas = React.createRef();
		this.assetRoot = "./assets/pc/";
		this.activeModel = null;
		this.activeSub = null;
		this.activeCamera = null;
		this.videoBackground = null;
		this.settings = {
			CONFIG_FILENAME: "config.json",
			SCENE_PATH: 1,
			CONTEXT_OPTIONS: 1,
			PRELOAD_MODULES: 1
		}
		this.fov = 15;
		//this.init = this.init.bind(this);
		//this.applyGraphNode = this.applyGraphNode.bind(this);
		//this.toggleCamera = this.toggleCamera.bind(this);
		//this.switchModelsAndHotspots = this.switchModelsAndHotspots.bind(this);
		this.sceneLoaded=false;
		socketIOService.init(this);
	}

	componentDidMount() {
    fetch(this.assetRoot + "__settings__.js")
		.then(response => response.text())
		.then(rawSettings => {
			rawSettings = rawSettings.replace(/\n|\r|window./g, '').replace(/'/g, '"').split(';');
			rawSettings.map(line => {
				let [key, val] = line.split(' = ');
				if (this.settings[key]) {
					val = JSON.parse(val.replace(/},]/g, '}]'));
					this.settings[key] = val;
				}
			});

			this.pcApp = new pc.Application(this.canvas.current, {
						mouse: new pc.Mouse(this.canvas.current),
						keyboard: new pc.Keyboard(window),
						fillMode: pc.FILLMODE_FILL_WINDOW,
						graphicsDeviceOptions: this.settings.CONTEXT_OPTIONS,
						touch: pc.platform.touch ? new pc.TouchDevice(window) : null,
						scriptPrefix: this.assetRoot,
						assetPrefix: this.assetRoot
					});

			this.pcApp.renderer.device._maxPixelRatio = 2;
			this.pcApp.renderer.device.canvas.style.imageRendering = ["auto", "pixelated", "crisp-edges"][2];

			this.pcApp.start();

			let basisConfig = {
				glueUrl: this.assetRoot + this.settings.PRELOAD_MODULES[0].glueUrl,
				wasmUrl: this.assetRoot + this.settings.PRELOAD_MODULES[0].wasmUrl,
				fallbackUrl: this.assetRoot + this.settings.PRELOAD_MODULES[0].fallbackUrl
			};

			pc.basisInitialize(basisConfig);
			this.loadScene(this.assetRoot + this.settings.CONFIG_FILENAME, this.settings.SCENE_PATH, this.props.pcLoading, this.init);

			this.pcApp.on('update', (deltaTime) => this.pcUpdate(deltaTime));
			this.pcApp.on('hotspot', this.hotspotClick);
			this.pcApp.keyboard.on(pc.EVENT_KEYUP, this.onKeyUp, this);
		});
	}

	pcUpdate = deltaTime => {
		if(this.class === 'playCanvas-open') {
			if (this.camera && this.props.mode === "kiosk") {
				let root = Utils.parseGraphNode(this.pcApp.root.findByName("ReplicatedEveryFrame"));
				socketIOService.send(root);
			}
		}
	}

    onKeyUp(event) {
		if(event.key == pc.KEY_H) {
			this.pcApp.root.findByName("Hotspots").enabled = !this.pcApp.root.findByName("Hotspots").enabled;

			if(this.pcApp.root.findByName("Hotspots").enabled) {
				document.getElementById("title").style.display = "block";
				document.getElementById("subTitle").style.display = "block";
				document.getElementById("logo").style.display = "block";
				document.getElementById("left_frame").style.display = "block";
				document.getElementById("filterButtons-wrapper").style.display = "block";
				document.getElementById("bottomBtns").style.display = "block";
				document.getElementById("closeButton").style.display = "block";
				document.getElementById("copyPane").style.display = "block";
				document.getElementById("thumbnails").style.display = "block";
				document.getElementById("nextArrow").style.display = "block";
				document.getElementById("prevArrow").style.display = "block";				
			} else {
				document.getElementById("title").style.display = "none";
				document.getElementById("subTitle").style.display = "none";
				document.getElementById("logo").style.display = "none";
				document.getElementById("left_frame").style.display = "none";
				document.getElementById("filterButtons-wrapper").style.display = "none";
				document.getElementById("bottomBtns").style.display = "none";
				document.getElementById("closeButton").style.display = "none";
				document.getElementById("copyPane").style.display = "none";
				document.getElementById("thumbnails").style.display = "none";
				document.getElementById("nextArrow").style.display = "none";
				document.getElementById("prevArrow").style.display = "none";	
			}
		}

		if(event.key == pc.KEY_C) {
			console.log("Camera Position: " + this.camera.getPosition().toString());
			console.log("Camera Rotation: " + this.camera.getEulerAngles().toString());
		}
    }

	sendOneTimeReplication(name){
		if (this.camera && this.props.mode === "kiosk") {
			let root = Utils.parseGraphNode(this.pcApp.root.findByName(name));
			socketIOService.send(root);
		}		
	}

	applyGraphNode = (graphNode) => {
		if (this.camera && this.props.mode === "wall")
		{
            Utils.applyJSONToGraphNode(graphNode, this.pcApp.root.findByName(graphNode.name));	
			let self=this;
			if(self.fov === 30){
				if(self.pcApp.root.findByName('Root').children)
				{
					for (let model of self.pcApp.root.findByName('Root').children)
					{
						for (let hs of (model.findByName("Hotspots")?.children || []))
						{
							let newHSScale = hs.getLocalScale();
							newHSScale.mulScalar(0.5);
							hs.setLocalScale(newHSScale);
						}
						
					}
				}
			}
		}	
	}

  	loadScene(configPath, scenePath, progress_callback, start_callback) {
		let self = this;
    	const setProgress = value => {
			if (progress_callback) {
				progress_callback(Math.round(value * 100));
			}
    	};

		self.pcApp.configure(configPath, function (err) {
			if (err) {
				console.error(err);
			}

			if(self.props.mode === "kiosk" || self.props.mode === "wall") {
				let assets = self.pcApp.assets.list();

				for (let i = 0; i < assets.length; i++) {
					var asset = assets[i];
					if (!asset.preload) {
						asset.preload = true;
					}
				}
			}

			self.pcApp.preload(function (err) {
				if (err) {
					console.error(err);
				}

				self.pcApp.scenes.loadScene(scenePath, function (err, scene) {
					if (err) {
						console.error(err);
					}

					self.pcApp.start();
				});
			});
		});

		this.pcApp.on('preload:end', () => {
			this.pcApp.off('preload:progress');
		});
		this.pcApp.on('preload:progress', setProgress);
		this.pcApp.on('start', () => {
			if (start_callback) {
				start_callback();
			}
			this.sceneLoaded=true;
		});
	}
	
	resizeCanvas() {
		if (this.props.mode !== 'wall') {
			let viewerWidth = document.getElementById('viewer').offsetWidth;
			let viewerHeight = document.getElementById('viewer').offsetHeight;
			this.canvas.current.width = viewerWidth;
			this.canvas.current.style.width = viewerWidth + "px";
			this.canvas.current.height = viewerHeight;
			this.canvas.current.style.height = viewerHeight + "px";
		}
		else
		{
			this.canvas.current.width = window.innerWidth;
			this.canvas.current.style.width = window.innerWidth + "px";
			this.canvas.current.height = window.innerHeight;
			this.canvas.current.style.height = window.innerHeight + "px";
		}
    }

	setCamera(camLocs){
        if(!this.isWall && this.camera?.script?.OrbitCamera){
            this.camera.script.OrbitCamera.setCameraAction(
                CameraData.camLocs[camLocs].distanceMax, 
                CameraData.camLocs[camLocs].distanceMin, 
                CameraData.camLocs[camLocs].pitchAngleMax, 
                CameraData.camLocs[camLocs].pitchAngleMin, 
                CameraData.camLocs[camLocs].yawAngleMax, 
                CameraData.camLocs[camLocs].yawAngleMin,
                CameraData.camLocs[camLocs].fov
            );
			this.camera.camera.fov = CameraData.camLocs[camLocs].fov;
            let cameraLoc = this.pcApp.root.findByName(CameraData.camLocs[camLocs].pos).getPosition().clone();
			let lookAtLoc = cameraLoc.clone();
			let forward = this.pcApp.root.findByName(CameraData.camLocs[camLocs].pos).forward.clone();
			let target = this.pcApp.root.findByName(CameraData.camLocs[camLocs].lookAt).getPosition().clone();
			let distance = cameraLoc.distance(target)
			forward.mulScalar(distance);
			lookAtLoc.add(forward);

            if(CameraData.camLocs[camLocs].forceLookAt)
                lookAtLoc=target;

            let resetLoc = CameraData.camLocs[camLocs].reset;
            let resetAnimateLoc = CameraData.camLocs[camLocs].resetAnimate;

            if(lookAtLoc && cameraLoc)
                this.camera.script.OrbitCamera.resetAndLookAtPoint(cameraLoc, lookAtLoc);
            if(resetLoc){ this.camera.script.OrbitCamera.reset(resetLoc.y, resetLoc.p, resetLoc.d); } 
            if(resetAnimateLoc){ this.camera.script.OrbitCamera.resetAnimate(resetAnimateLoc.y, resetAnimateLoc.p, resetAnimateLoc.d); }                      
        }        
    }

	init = () => {
		this.props.pcLoading("min hide");
		if(!this.camera)
		{
			this.camera = this.pcApp.root.findByName("Camera")

			this.camera.enabled = true;
			this.camera.addComponent('script');
			if(this.props.mode === "kiosk" || this.props.mode === "wall")
				this.camera.frustrumCulling = false;

			this.resizeCanvas();
			window.addEventListener('resize', this.resizeCanvas.bind(this));

			pc.registerScript(CustomLoading);
			this.camera.script.create(CustomLoading);

			if (this.props.mode !== 'wall') {
				pc.registerScript(OrbitCamera);
				this.camera.script.create(OrbitCamera);


				pc.registerScript(MouseInput);
				pc.registerScript(TouchInput);
				this.camera.script.create(MouseInput);
				this.camera.script.create(TouchInput);
				pc.registerScript(HotSpot);
				for (let model of this.pcApp.root.findByName('Root').children) {
					for (let hs of (model.findByName("Hotspots")?.children || [])) {
						hs.addComponent('script');
						hs.script.create(HotSpot);
						hs.enabled = false;
					}
				}
			}
		}
	}

	hotspotClick = name => {
		if(this.class === 'playCanvas-open')
    		this.props.toggleSHS(name);
		else
			return;
	}

	toggleCamera = (cameraName) => {
		if(cameraName)
		{
			if(this.activeCamera !== cameraName)
			{
				this.activeCamera = cameraName;
				this.setCamera(this.activeCamera);
			}
		}
	}

	switchModelsAndHotspots = (hotspot) => {
		let parts = hotspot.Parts || hotspot.SubHotspots;
		let self = this;

		for (let hs of (self.pcApp.root.findByName("Hotspots")?.children || []))
			hs.enabled = false;

		Object.keys(parts || {}).map(partName => {
			if(parts[partName].PCHotspotName)	{
				if( (parts[partName].Filter.some(el => self.props.filter.includes(el))) && self.props.pcHotspotsVisibility) {
					self.pcApp.root.findByName(parts[partName].PCHotspotName).enabled = true;
					self.pcApp.root.findByName(parts[partName].PCHotspotName).addComponent('script');
					self.pcApp.root.findByName(parts[partName].PCHotspotName).script.create(HotSpot);
				}
				if (this.props.mode !== 'wall') {
					if (CameraData && CameraData.camLocs[hotspot.Camera])
						self.pcApp.root.findByName(parts[partName].PCHotspotName).script.HotSpot.offset =  CameraData.camLocs[hotspot.Camera].offset;
				}
			}
		})

		if(hotspot.ModelsToShow){
			for(let i=0; i<hotspot.ModelsToShow.length; i++){
				self.pcApp.root.findByName(hotspot.ModelsToShow[i][0]).enabled = true;
				self.sendOneTimeReplication(hotspot.ModelsToShow[i][0]);
			}
		}
		if(hotspot.ModelsToHide){
			for(let i=0; i<hotspot.ModelsToHide.length; i++){
				self.pcApp.root.findByName(hotspot.ModelsToHide[i][0]).enabled = false;
				self.sendOneTimeReplication(hotspot.ModelsToHide[i][0]);
			}
		}
	}

	render() {
		const hotspot = this.props.subhotspot || this.props.hotspot;
		if(hotspot)
		{
			if(hotspot.Model){
				this.class = 'playCanvas-open';
				if(document.getElementById("bgVideo"))
					if(!document.getElementById("bgVideo").paused)
						document.getElementById("bgVideo").pause();
				if(this.pcApp){
					this.pcApp.timeScale = 1;

					if(this.currentScene !== hotspot.Model) {		
						let self=this;
						this.previousScene = this.currentScene;
						this.currentScene = hotspot.Model;
						let newScene = this.pcApp.scenes.find(hotspot.Model);
						let oldHierarchy = this.pcApp.root.findByName(this.previousScene);
						let newTag = hotspot.Tag ? hotspot.Tag : hotspot.Model;
						let assetsToLoad = this.pcApp.assets.findByTag(newTag);
						let assestTotal = assetsToLoad.length;
						let assetsLoaded = 0;
						let onAssetReady = function(asset) {
							assetsLoaded += 1;

							if(self.props.mode !== "kiosk" && self.props.mode !== "wall"){
								try 
								{
									self.pcApp.fire("loading:progress",assetsLoaded/assestTotal); 
								}
								catch(err) 
								{        
									console.error(err);     
								}
							}

							if (assetsLoaded === assestTotal) {
								self.pcApp.scenes.loadSceneHierarchy(newScene.url, function (err, parent) {
									if (!err) {
										if(oldHierarchy !== null) {
											oldHierarchy.destroy();
											if(self.props.mode !== "kiosk" && self.props.mode !== "wall") {
												let assets = self.pcApp.assets.findByTag(self.previousScene);
												for(let a = 0; a <assets.length; a++)
												{
													if(assets[a].loaded)
													{
														if(!assets[a].tags.has(self.currentScene) && !assets[a].tags.has(newTag))
														{
																assets[a].unload();
														}
													}
												}
											}
										}
										try
										{
											self.pcApp.fire("finishedLoading");
										}
										catch(err)
										{
											console.error(err);    
										}
										if(hotspot.Camera)
											self.toggleCamera(hotspot.Camera);
										self.switchModelsAndHotspots(hotspot);	
									} else
										console.error(err);
								});
							}        
						}; 

						if(assestTotal === 0)
							console.log("Nothing to load");
						else {
							self.pcApp.fire("loading");     
							for(let a = 0; a < assetsToLoad.length; a++)
							{ 
								assetsToLoad[a].ready(onAssetReady,assetsToLoad[a]);
								if(!assetsToLoad[a].loaded)
									self.pcApp.assets.load(assetsToLoad[a]);
							}							
						}
						
					} else {
						if(hotspot.Camera)
							this.toggleCamera(hotspot.Camera);

						this.switchModelsAndHotspots(hotspot);
					}
				}			
			}
			else if(!hotspot.PCHotspotName && !this.props.hotspot?.Camera) {
				this.class = 'playCanvas-closed';
				if(document.getElementById("bgVideo"))
					if(document.getElementById("bgVideo").paused)
						document.getElementById("bgVideo").play();
				if(this.pcApp)
					this.pcApp.timeScale = 0;
			}
			else if(this.currentScene !== "") {
				if(hotspot.Camera)
					this.toggleCamera(hotspot.Camera);
				this.switchModelsAndHotspots(hotspot);
			}
			if(this.props.mode === 'wall') {
				if(hotspot.Camera)
					this.fov = CameraData.camLocs[hotspot.Camera].fov;
			}
		}
		else
		{
			this.class = 'playCanvas-closed'
			if(document.getElementById("bgVideo"))
				if(document.getElementById("bgVideo").paused)
					document.getElementById("bgVideo").play();
			if(this.pcApp)
				this.pcApp.timeScale = 0;
		}
		return (
			<canvas ref={this.canvas} id="pcCanvas" className={this.class} />
		);
	}
}
export default PlayCanvasComponent;